module.exports = __webpack_public_path__ + "img/confirm1_en.4d68a5ca.jpg";